<header class="z-50 bg-white flex flex-wrap overflow-hidden items-center md:items-stretch">
    <div class="w-full overflow-hidden pl-5 text-dark font-bold uppercase mb-2 md:mb-5 md:pl-12 md:mt-5">
      <a class="tracking-wider" [routerLink]="[link]">
        <span class="pr-2"><i class="fas fa-chevron-left text-green"></i></span>
        {{ 'globals.back' | transloco }}
      </a>
    </div>
  </header>
